export default __webpack_public_path__ + "static/media/brown-arrow.6cac2d2d.svg";